"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ErrorParagraph = _interopRequireDefault(require("../../Typography/ErrorParagraph"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ErrorDiv = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 1.75rem;\n    margin: ", ";\n"])), function (props) {
  return props.margin || 'unset';
});

var Errors = function Errors(_ref) {
  var errors = _ref.errors,
      margin = _ref.margin,
      _ref$t = _ref.t,
      t = _ref$t === void 0 ? function (v) {
    return v;
  } : _ref$t;
  return _react.default.createElement(ErrorDiv, {
    margin: margin
  }, errors && errors.filter(Boolean).map(function (error) {
    return _react.default.createElement(_ErrorParagraph.default, {
      key: error,
      error: error,
      value: t(error.id || error, error.data),
      "data-cy": error.id || error
    });
  }));
};

var _default = Errors;
exports.default = _default;